An array of additional address lines.

These may include an apartment or suite number.

A maximum of 5 extended lines may be provided.
